import ServiceClient from "./serviceClientConfig";

const serviceClient = new ServiceClient({
  baseURL: process.env.REACT_APP_APIS,
});

export const fetchUploadURL = () => {
  return serviceClient.post("v1/tempUploadURL");
};
